import React from 'react';

interface CategoryInfoButtonProps {
  categoryName: string;
  onCategoryInfoClick: (categoryName: string) => void;
  className?: string;
}

/**
 * Reusable component for category info buttons.
 * Displays an info icon button that opens a category info modal when clicked.
 */
const CategoryInfoButton: React.FC<CategoryInfoButtonProps> = ({
  categoryName,
  onCategoryInfoClick,
  className = ''
}) => {
  return (
    <button
      onClick={() => onCategoryInfoClick(categoryName)}
      className={`inline-flex items-center justify-center w-5 h-5 ml-1 rounded-full text-gray-900 dark:text-text-primary hover:text-primary dark:hover:text-highlight-gold hover:bg-primary/10 dark:hover:bg-highlight-gold/10 transition-colors align-middle ${className}`}
      title={`Learn more about ${categoryName}`}
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" strokeWidth="2"/>
        <path d="M12 16v-4" strokeWidth="2" strokeLinecap="round"/>
        <path d="M12 8h.01" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    </button>
  );
};

export default CategoryInfoButton;

